module.exports = __webpack_public_path__ + "static/media/reply.10a95c2e.svg";